import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { ResidentialService } from '../../residential.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// import { DatePipe } from '@angular/common';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';

@Component({
  selector: 'app-r-q4',
  templateUrl: './r-q4.component.html',
  styleUrls: ['./r-q4.component.css', '../residential-question.component.css'],
  // providers: [DatePipe],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RQ4Component implements OnInit {
  @Input() data: any;
  isDisable: Boolean = false;
  date;
  typeOfSwitch;
  hgSwitch;
  question;
  questions;
  isChecked = false;
  showbutton = true;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  nextId;
  deviceWidth;
  ignored = false;
  standarad_id;
  self_id;
  modalRef: BsModalRef;
  tableElements = [
    {
      thead: 'Move In',
      rowElements: [
        '$3.00',
        '$1.00',
        '$16.00',
        '$1.00',
        '$0.70',
        '$49.80',
        '$1.50',
      ],
    },
    {
      thead: 'Priority Move In',
      rowElements: [
        '$9.00',
        '$5.00',
        '$36.00',
        '$2.00',
        '$1.70',
        '$79.27',
        '$26.50',
      ],
    },
    {
      thead: 'Self-Select Switch',
      rowElements: [
        '$0.00',
        '$0.00',
        '$0.00',
        '$3.00',
        '$0.15',
        '$7.00',
        '$0.40',
      ],
    },
    {
      thead: 'Standard Switch',
      rowElements: [
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
        '$0.00',
      ],
    },
  ];
  thead;
  rowElements = [];
  tableIndex;
  timer;
  tduRates: any;
  private loadActualUtilityName = {
    AEPC: 'AEP Texas Central',
    AEPN: 'AEP Texas North',
    TNMP: 'Texas New Mexico Power',
    CNP: 'Centerpoint',
    ONC: 'Oncor',
    SHAR: 'Sharyland Utility',
    NUEC: 'NEC',
  };

  constructor(
    private residentialService: ResidentialService,
    private router: Router,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef
  ) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
    this.hgSwitch = {
      value1: false,
      value2: false,
    };
    this.thead = this.tableElements[0].thead;
    this.rowElements = this.tableElements[0].rowElements;
    this.tableIndex = 0;
  }

  ngOnInit() {
    this.getTduRatesForAllUtilityNames();
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.standarad_id = document.getElementById('Standard Switch_mob');
      this.self_id = document.getElementById('Self-Selected Switch_mob');
    } else {
      this.standarad_id = document.getElementById('Standard Switch');
      this.self_id = document.getElementById('Self-Selected Switch');
    }
    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ nextId: '0014' });
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        res_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.typeOfSwitch = obj.fieldValue;
        this.isChecked = true;
        if (this.typeOfSwitch === 'Standard Switch') {
          this.hgSwitch = {
            value1: true,
            value2: false,
          };
          this.standarad_id.parentElement.parentElement.classList.add(
            'active-select'
          );
          this.isDisable = false;
        } else if (this.typeOfSwitch === 'Self-Selected Switch') {
          this.hgSwitch = {
            value1: false,
            value2: true,
          };
          this.self_id.parentElement.parentElement.classList.add(
            'active-select'
          );
          this.isDisable = false;
        }
        this.user_bot = true;
        if (this.deviceWidth < 768) {
          this.goNext();
        }
      }
    }

    if(!this.hgSwitch.value1 && !this.hgSwitch.value2 )
    {
      this.showbutton = false;
    }
  }

  getSwitchDate(event) {
    this.typeOfSwitch = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
      if (event.target.value === 'Self-Selected Switch') {
        this.hgSwitch = {
          value1: false,
          value2: true,
        };
        this.self_id.parentElement.parentElement.classList.add('active-select');
        if (
          _.contains(
            this.standarad_id.parentElement.parentElement.classList,
            'active-select'
          )
        ) {
          this.standarad_id.parentElement.parentElement.classList.remove(
            'active-select'
          );
        }
      } else {
        this.hgSwitch = {
          value1: true,
          value2: false,
        };
        this.standarad_id.parentElement.parentElement.classList.add(
          'active-select'
        );
        if (
          _.contains(
            this.self_id.parentElement.parentElement.classList,
            'active-select'
          )
        ) {
          this.self_id.parentElement.parentElement.classList.remove(
            'active-select'
          );
        }
      }
      this.user_bot = true;
      this.ref.detectChanges();
    } else {
      this.hgSwitch = {
        value1: false,
        value2: false,
      };
      this.typeOfSwitch = '';
      if (
        _.contains(
          this.self_id.parentElement.parentElement.classList,
          'active-select'
        )
      ) {
        this.self_id.parentElement.parentElement.classList.remove(
          'active-select'
        );
      }
      if (
        _.contains(
          this.standarad_id.parentElement.parentElement.classList,
          'active-select'
        )
      ) {
        this.standarad_id.parentElement.parentElement.classList.remove(
          'active-select'
        );
      }
      this.user_bot = false;
      this.ref.detectChanges();
    }
    if (this.typeOfSwitch === this.questionObj.hg_res_rules[0].parameter) {
      this.nextId = this.questionObj.hg_res_rules[0].res_question_id;
    } else {
      this.nextId = '';
    }
    // console.log.log(this.nextId);
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
      if(!this.showbutton)
      {
        this.next();
      }

    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  next() {
    if (_.isEmpty(this.typeOfSwitch)) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
    } else {
      if (_.isEmpty(this.nextId)) {
        if (this.typeOfSwitch === this.questionObj.hg_res_rules[0].parameter) {
          this.nextId = this.questionObj.hg_res_rules[0].res_question_id;
        } else {
          this.nextId = '';
        }
      }
      this.residentialService.setNextId(this.nextId);
      this.residentialService.messageService({
        currentId: this.data,
        nextId: this.nextId,
      });
    }
  }
  signUp() {
    this.residentialService.userResponse.userResponses.length = 3;
    this.router.navigateByUrl('/signup');
  }

  ignore() {
    this.isDisable = false;
    this.ignored = true;
  }

  // This function is used for to save the data in DB
  save() {
    const Obj = {
      res_question_id: this.data,
      fieldName: 'typeOfSwitch_sp',
      fieldValue: this.typeOfSwitch,
    };
    if (this.typeOfSwitch === 'Standard Switch') {
      const foundElem = _.findWhere(
        this.residentialService.userResponse.userResponses,
        { res_question_id: '005' }
      );
      if (foundElem !== undefined) {
        this.residentialService.userResponse.userResponses = _.without(
          this.residentialService.userResponse.userResponses,
          foundElem
        );
      }
    }
    this.residentialService.updateResponses(Obj);
  }

  prevTab() {
    if (this.tableIndex > 0 || this.tableIndex === 0) {
      this.tableIndex = this.tableIndex - 1;
      this.rowElements = this.tableElements[this.tableIndex].rowElements;
      this.thead = this.tableElements[this.tableIndex].thead;
      this.ref.markForCheck();
    }
  }

  nextTab() {
    if (this.tableIndex < 4) {
      this.tableIndex = this.tableIndex + 1;
      this.rowElements = this.tableElements[this.tableIndex].rowElements;
      this.thead = this.tableElements[this.tableIndex].thead;
      this.ref.markForCheck();
    }
  }

  getTduRatesForAllUtilityNames() {
    this.residentialService
      .getTduIdForAllUtilityNames()
      .subscribe((res: any) => {
        this.tduRates = res;
      });
  }

  getActualUtilityName(utilName) {
    return this.loadActualUtilityName[utilName];
  }
  checkForWholeOrDecimal(number) {
    if (number == Math.floor(number)) {
      return `${number}.00`;
    } else {
      const newValue = number.toString();
      const newString =
        newValue.substring(newValue.indexOf('.') + 1).length >= 2
          ? newValue.substring(newValue.indexOf('.') + 1)
          : `${newValue.substring(newValue.indexOf('.') + 1)}0`;
      return `${newValue.substring(0, newValue.indexOf('.'))}.${newString}`;
    }
  }
}
